/**
 * Utility script to make a user an administrator
 * This can be run from the browser console or as a standalone script
 */

import UserManagementUtils from './userManagement.js';

/**
 * Make clymusa@gmail.com an administrator
 * Usage: Call this function from the browser console when logged in as an admin
 */
export async function makeClymusaAdmin() {
  try {
    console.log('Attempting to make clymusa@gmail.com an administrator...');
    
    // You need to be logged in as an admin to run this
    // Get the current user from Firebase Auth
    const { auth } = await import('../firebase.js');
    const { onAuthStateChanged } = await import('firebase/auth');
    
    return new Promise((resolve, reject) => {
      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          reject(new Error('No user logged in. Please log in as an administrator first.'));
          return;
        }
        
        try {
          // Get user profile to check if they're admin
          const { doc, getDoc } = await import('firebase/firestore');
          const { db } = await import('../firebase.js');
          
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          if (!userDoc.exists()) {
            reject(new Error('User profile not found. Please log in again.'));
            return;
          }
          
          const userProfile = userDoc.data();
          if (userProfile.role !== 'admin') {
            reject(new Error('Only administrators can make other users admin.'));
            return;
          }
          
          // Make clymusa@gmail.com an admin
          const result = await UserManagementUtils.makeUserAdmin(
            'clymusa@gmail.com',
            user.uid,
            user.email
          );
          
          console.log('Success:', result.message);
          resolve(result);
        } catch (error) {
          console.error('Error:', error.message);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('Error making user admin:', error);
    throw error;
  }
}

/**
 * Check if clymusa@gmail.com exists and what their current role is
 */
export async function checkClymusaStatus() {
  try {
    const user = await UserManagementUtils.findUserByEmail('clymusa@gmail.com');
    if (!user) {
      console.log('clymusa@gmail.com not found in the system');
      return null;
    }
    
    console.log('clymusa@gmail.com found:');
    console.log('- ID:', user.id);
    console.log('- Email:', user.email);
    console.log('- Name:', user.firstName, user.lastName);
    console.log('- Role:', user.role);
    console.log('- Organization:', user.organizationName);
    console.log('- Created:', user.createdAt);
    
    return user;
  } catch (error) {
    console.error('Error checking user status:', error);
    throw error;
  }
}

// Make functions available globally for console use
if (typeof window !== 'undefined') {
  window.makeClymusaAdmin = makeClymusaAdmin;
  window.checkClymusaStatus = checkClymusaStatus;
  console.log('Admin utilities loaded. Use makeClymusaAdmin() or checkClymusaStatus() in the console.');
}
